var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"sinopsi container py-5",attrs:{"id":"espectacle"}},[_c('h1',[_vm._v(_vm._s(_vm.$t('spectacle_name'))+" ")]),_c('div',{staticClass:"py-4"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('s1'))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('s2'))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('s3'))+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }